import AxiosService from "../AxiosService";

const PHOTO_ENDPOINT = "/api/v1/photo"

export class PhotoService {
  constructor() {
    this.service = new AxiosService();
  }

  savePhoto(formData) {
    return this.service.post(PHOTO_ENDPOINT, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}